function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { FeatureToggleConstants, i18n, InjectorHelper } from 'invision-core';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { RIGHT_ALIGNED_HEADER_TEMPLATE } from 'invision-ui/lib/components/collections/datatable/cellTemplates/cellTemplates';
import { map, pathOr } from 'ramda';
import LocaleKeys from '../../locales/keys';
import { DISPUTE_INVOICE, PAYMENT_ADJUSTMENT_ACCESS } from '../../security.attributes';
import { INVOICE_ITEM_TYPES, NA, TAX_TYPE } from '../constants/billing.payments.constants';
var formatChargeDate = function formatChargeDate(periodStart, periodEnd, view) {
  var $filter = InjectorHelper.getFilterService();
  var prorate = view.Prorate ? i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.PRORATED) : '';
  if (periodStart && periodEnd) {
    if (periodStart === periodEnd) {
      return i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.PERIOD_FORMAT_SINGLE, {
        additional_info: prorate,
        periodStart: $filter('localShortDate')(periodStart)
      });
    } else {
      return i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.PERIOD_FORMAT, {
        additional_info: prorate,
        periodStart: $filter('localShortDate')(periodStart),
        periodEnd: $filter('localShortDate')(periodEnd)
      });
    }
  }
  return null;
};
function formatTaxBreakdown(taxBreakdown, currency, $filter) {
  var formattedTaxBreakdown = [];
  if (taxBreakdown && taxBreakdown.length > 0) {
    taxBreakdown.forEach(function (tax) {
      formattedTaxBreakdown.push({
        TaxTypeName: tax.TaxTypeName,
        TaxAmount: $filter('invCurrency')(tax.TaxAmount, currency, false, true)
      });
    });
  }
  return formattedTaxBreakdown;
}
function getTaxMethod(view) {
  var _view$OriginalCharge;
  if (view !== null && view !== void 0 && (_view$OriginalCharge = view.OriginalCharge) !== null && _view$OriginalCharge !== void 0 && _view$OriginalCharge.TaxMethod) {
    var _view$OriginalCharge2;
    return (view === null || view === void 0 ? void 0 : (_view$OriginalCharge2 = view.OriginalCharge) === null || _view$OriginalCharge2 === void 0 ? void 0 : _view$OriginalCharge2.TaxMethod) === TAX_TYPE.INCLUSIVE ? i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.TAX_INCLUSIVE) : i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.TAX_EXCLUSIVE);
  }
  return null;
}
;
function calculateTotalChargeAmount(view) {
  var _view$TotalCharge, _view$TotalCharge2;
  var discountAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var isTaxInclusiveTagDisplayEnabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var chargeField = isTaxInclusiveTagDisplayEnabled ? 'BaseAmount' : 'ChargeAmount';
  if ((view === null || view === void 0 ? void 0 : (_view$TotalCharge = view.TotalCharge) === null || _view$TotalCharge === void 0 ? void 0 : _view$TotalCharge[chargeField]) !== null && (view === null || view === void 0 ? void 0 : (_view$TotalCharge2 = view.TotalCharge) === null || _view$TotalCharge2 === void 0 ? void 0 : _view$TotalCharge2[chargeField]) !== undefined) {
    return view.TotalCharge[chargeField];
  }
  // If TotalCharge is not available, fallback to Amount to support older invoice items(ACB)
  if ((view === null || view === void 0 ? void 0 : view.Amount) !== null && (view === null || view === void 0 ? void 0 : view.Amount) !== undefined) {
    return view.Amount + discountAmount;
  }
  return null;
}
function calculateTotalCharge(view, currency, $filter, discountAmount) {
  var _view$TotalCharge3, _view$TotalCharge4;
  var isTaxInclusiveTagDisplayEnabled = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var chargeField = isTaxInclusiveTagDisplayEnabled ? 'BaseAmount' : 'ChargeAmount';
  if ((view === null || view === void 0 ? void 0 : (_view$TotalCharge3 = view.TotalCharge) === null || _view$TotalCharge3 === void 0 ? void 0 : _view$TotalCharge3[chargeField]) !== null && (view === null || view === void 0 ? void 0 : (_view$TotalCharge4 = view.TotalCharge) === null || _view$TotalCharge4 === void 0 ? void 0 : _view$TotalCharge4[chargeField]) !== undefined) {
    return $filter('invCurrency')(view.TotalCharge[chargeField], currency, false, true);
  }
  // If TotalCharge is not available, fallback to Amount to support older invoice items(ACB)
  if ((view === null || view === void 0 ? void 0 : view.Amount) !== null && (view === null || view === void 0 ? void 0 : view.Amount) !== undefined) {
    return $filter('invCurrency')(view.Amount + discountAmount, currency, false, true);
  }
  return null;
}
function calculateTotalChargeForApplyAdjustment(view) {
  var _view$TotalCharge5, _view$TotalCharge6;
  var discountAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if ((view === null || view === void 0 ? void 0 : (_view$TotalCharge5 = view.TotalCharge) === null || _view$TotalCharge5 === void 0 ? void 0 : _view$TotalCharge5.ChargeAmount) !== null && (view === null || view === void 0 ? void 0 : (_view$TotalCharge6 = view.TotalCharge) === null || _view$TotalCharge6 === void 0 ? void 0 : _view$TotalCharge6.ChargeAmount) !== undefined) {
    var _view$TotalCharge7, _view$TotalCharge8, _view$TotalCharge9;
    return (view === null || view === void 0 ? void 0 : (_view$TotalCharge7 = view.TotalCharge) === null || _view$TotalCharge7 === void 0 ? void 0 : _view$TotalCharge7.TaxMethod) === TAX_TYPE.INCLUSIVE ? view === null || view === void 0 ? void 0 : (_view$TotalCharge8 = view.TotalCharge) === null || _view$TotalCharge8 === void 0 ? void 0 : _view$TotalCharge8.BaseAmount : view === null || view === void 0 ? void 0 : (_view$TotalCharge9 = view.TotalCharge) === null || _view$TotalCharge9 === void 0 ? void 0 : _view$TotalCharge9.ChargeAmount;
  }
  // If TotalCharge is not available, fallback to Amount to support older invoice items(ACB)
  if ((view === null || view === void 0 ? void 0 : view.Amount) !== null && (view === null || view === void 0 ? void 0 : view.Amount) !== undefined) {
    return view.Amount + discountAmount;
  }
  return null;
}
export function createInvoiceItemsTableViewModel(invoiceItems, invoiceSummary, invoiceItemTypes, canApplyAdjustment) {
  var discountsMetadataMap = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var userSecurityAttributes = arguments.length > 5 ? arguments[5] : undefined;
  var witheldTaxesApplicable = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var currentCustomer = arguments.length > 7 ? arguments[7] : undefined;
  var features = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : {};
  var buFeatures = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : {};
  var tableData = {
    columnDefs: [{
      field: 'subscriberItem',
      displayName: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.SUBSCRIBER_ITEM),
      cellTemplate: require('./../../components/billingPayments/cellTemplates/item.template.html'),
      width: '*',
      minWidth: 150,
      resizable: true,
      enableSorting: true,
      enableColumnMoving: false
    }, {
      field: 'serviceType',
      displayName: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.SERVICE_TYPE),
      cellTemplate: require('./../../components/billingPayments/cellTemplates/service.type.template.html'),
      width: '*',
      minWidth: 150,
      resizable: true,
      enableSorting: true,
      enableColumnMoving: false
    }, {
      field: 'serviceName',
      displayName: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.SERVICE_NAME),
      width: '*',
      minWidth: 100,
      resizable: true,
      enableSorting: true,
      enableColumnMoving: false,
      cellTemplate: require('./../../components/billingPayments/cellTemplates/service.name.html')
    }, {
      field: 'chargePeriod',
      displayName: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.CHARGE_PERIOD),
      cellTemplate: require('./../../components/billingPayments/cellTemplates/charge.period.html'),
      width: '*',
      minWidth: 180,
      resizable: true,
      enableSorting: true,
      enableColumnMoving: false
    }, {
      field: 'originalCharge',
      displayName: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.ORIGINAL_CHARGE),
      cellTemplate: require('./../../components/billingPayments/cellTemplates/original.charge.template.html'),
      headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE,
      width: '150',
      cellClass: 'c-dataType-number',
      minWidth: 70,
      resizable: true,
      enableSorting: true,
      enableColumnMoving: false
    }, {
      field: 'discount',
      displayName: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.DISCOUNT),
      cellTemplate: require('./../../components/billingPayments/cellTemplates/discount.template.html'),
      headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE,
      width: '125',
      cellClass: 'c-dataType-number',
      minWidth: 70,
      resizable: true,
      enableSorting: true,
      enableColumnMoving: false
    }].concat(_toConsumableArray(witheldTaxesApplicable ? [{
      field: 'withheldTaxes',
      headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE,
      displayName: 'Withheld Taxes',
      width: '120',
      cellClass: 'c-dataType-number',
      resizable: true,
      enableColumnMoving: false
    }] : []), [{
      field: 'totalCharge',
      displayName: i18n.translate(LocaleKeys.BILLING_AND_PAYMENT_INVOICE.TOTAL_CHARGE),
      cellTemplate: require('./../../components/billingPayments/cellTemplates/total.charge.template.html'),
      headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE,
      width: '132',
      cellClass: 'c-dataType-number',
      minWidth: 70,
      resizable: true,
      enableSorting: true,
      enableColumnMoving: false
    }, {
      field: 'moreAction',
      displayName: '',
      cellTemplate: require('./../../components/billingPayments/cellTemplates/more.actions.template.html'),
      width: 70,
      maxWidth: 70,
      enableColumnMoving: false
    }])
  };
  var $filter = InjectorHelper.getFilterService();
  var isTaxInclusiveTagDisplayEnabled = !!(buFeatures !== null && buFeatures !== void 0 && buFeatures.InvEnableDiscountAndTaxInclusiveTagDisplay);
  var formatView = function formatView(view) {
    if (typeof view === 'undefined') {
      return {};
    } else {
      var _invoiceItemTypes$fin, _view$CaseId2, _view$OriginalCharge5, _view$OriginalCharge6, _view$OriginalCharge7, _view$OriginalCharge8, _view$OriginalCharge9, _view$OriginalCharge10, _view$OriginalCharge11, _view$TotalCharge10, _view$TotalCharge11, _view$TotalCharge12, _view$TotalCharge13;
      var isCreditType = (invoiceSummary === null || invoiceSummary === void 0 ? void 0 : invoiceSummary.CurrentDue) < 0;
      var currency = view.CurrencyCode || (invoiceSummary === null || invoiceSummary === void 0 ? void 0 : invoiceSummary.CurrencyCode) || currentCustomer.SubscriberCurrency;
      var discountAmount = getDiscountAmount(view);
      var discountDetails = getDiscountsDetails(currency, view.Discounts || [], discountsMetadataMap);
      var moreOptions = [];
      var showApplyAdjustment = view.ItemType === INVOICE_ITEM_TYPES.TAX_ITEM || view.ItemType === INVOICE_ITEM_TYPES.USAGE_SUMMARY || view.ItemType === INVOICE_ITEM_TYPES.BILLING_FEES || view.ItemType === INVOICE_ITEM_TYPES.LATE_PAYMENT_FEE ? false : canApplyAdjustment;
      if (showApplyAdjustment && hasAccess(userSecurityAttributes, PAYMENT_ADJUSTMENT_ACCESS) && !isCreditType) {
        moreOptions.push({
          id: 'APPLY_ITEM_ADJUSTMENT',
          title: i18n.translate(LocaleKeys.ADJUSTMENTS.APPLY_ITEM_ADJUSTMENT)
        });
      }
      if (features[FeatureToggleConstants.IS_LINE_ITEM_DISPUTE_AVAILABLE] && !isCreditType) {
        var _view$CaseId;
        if ((_view$CaseId = view.CaseId) !== null && _view$CaseId !== void 0 && _view$CaseId.Value) {
          moreOptions.push({
            id: 'VIEW_CASE_DETAILS',
            title: i18n.translate(LocaleKeys.CASE.VIEW_CASE_DETAILS)
          });
        } else {
          var _invoiceSummary$CaseI;
          if (showApplyAdjustment && !(invoiceSummary !== null && invoiceSummary !== void 0 && invoiceSummary.IsStatement) && hasAccess(userSecurityAttributes, DISPUTE_INVOICE) && !(invoiceSummary !== null && invoiceSummary !== void 0 && (_invoiceSummary$CaseI = invoiceSummary.CaseId) !== null && _invoiceSummary$CaseI !== void 0 && _invoiceSummary$CaseI.Value)) {
            moreOptions.push({
              id: 'DISPUTE_LINE_ITEM',
              title: i18n.translate(LocaleKeys.DISPUTE_LINE_ITEM)
            });
          }
        }
      }
      var invoiceItemTypeName = (_invoiceItemTypes$fin = invoiceItemTypes.find(function (item) {
        return +item.Value === view.ItemType;
      })) === null || _invoiceItemTypes$fin === void 0 ? void 0 : _invoiceItemTypes$fin.Name;
      var getOriginalCharge = function getOriginalCharge(view, currency, $filter) {
        var _view$OriginalCharge3, _view$OriginalCharge4;
        var chargeField = isTaxInclusiveTagDisplayEnabled ? 'BaseAmount' : 'ChargeAmount';
        var amount = (view === null || view === void 0 ? void 0 : (_view$OriginalCharge3 = view.OriginalCharge) === null || _view$OriginalCharge3 === void 0 ? void 0 : _view$OriginalCharge3[chargeField]) !== undefined ? view === null || view === void 0 ? void 0 : (_view$OriginalCharge4 = view.OriginalCharge) === null || _view$OriginalCharge4 === void 0 ? void 0 : _view$OriginalCharge4[chargeField] : view.Amount;
        return amount ? $filter('invCurrency')(amount, currency, false, true) : null;
      };
      return _objectSpread({
        accountNumber: view.AccountNumber,
        applyAdjustment: '',
        canApplyAdjustment: view.ItemType === INVOICE_ITEM_TYPES.TAX_ITEM || view.ItemType === INVOICE_ITEM_TYPES.USAGE_SUMMARY || view.ItemType === INVOICE_ITEM_TYPES.BILLING_FEES ? false : canApplyAdjustment,
        caseId: (_view$CaseId2 = view.CaseId) === null || _view$CaseId2 === void 0 ? void 0 : _view$CaseId2.Value,
        chargePeriod: formatChargeDate(view.PeriodStartDate, view.PeriodEndDate, view),
        currencyCode: currency,
        date: view.Date || null,
        discount: discountAmount || discountDetails.length ? $filter('invCurrency')(discountAmount, currency, false, true) : null,
        discounts: discountDetails,
        discountTemplate: require('./../../components/billingPayments/cellTemplates/discount.tooltip.template.html'),
        discountToolTipText: discountDetails.length,
        discountNegative: discountAmount || discountDetails.length ? discountAmount <= 0 : false,
        invoiceId: view.InvoiceId || null,
        itemId: view.EventId,
        invoiceItemId: view.InvoiceItemId,
        invoiceItemBalance: view.Amount,
        invoiceItemMaxDisputableAmount: pathOr(undefined, ['MaxDisputableAmount'], view),
        moreOptions: moreOptions,
        originalCharge: getOriginalCharge(view, currency, $filter),
        originalChargeNegative: isTaxInclusiveTagDisplayEnabled ? view !== null && view !== void 0 && view.OriginalCharge ? (view === null || view === void 0 ? void 0 : (_view$OriginalCharge5 = view.OriginalCharge) === null || _view$OriginalCharge5 === void 0 ? void 0 : _view$OriginalCharge5.BaseAmount) < 0 : view.Amount < 0 : view !== null && view !== void 0 && view.OriginalCharge ? (view === null || view === void 0 ? void 0 : (_view$OriginalCharge6 = view.OriginalCharge) === null || _view$OriginalCharge6 === void 0 ? void 0 : _view$OriginalCharge6.ChargeAmount) < 0 : view.Amount < 0,
        originalChargeDetails: {
          taxMethod: view === null || view === void 0 ? void 0 : (_view$OriginalCharge7 = view.OriginalCharge) === null || _view$OriginalCharge7 === void 0 ? void 0 : _view$OriginalCharge7.TaxMethod,
          baseAmount: view !== null && view !== void 0 && (_view$OriginalCharge8 = view.OriginalCharge) !== null && _view$OriginalCharge8 !== void 0 && _view$OriginalCharge8.BaseAmount ? $filter('invCurrency')(view.OriginalCharge.BaseAmount, currency, false, true) : null,
          chargeAmount: view !== null && view !== void 0 && (_view$OriginalCharge9 = view.OriginalCharge) !== null && _view$OriginalCharge9 !== void 0 && _view$OriginalCharge9.ChargeAmount ? $filter('invCurrency')(view.OriginalCharge.ChargeAmount, currency, false, true) : null,
          totalTaxAmount: view !== null && view !== void 0 && (_view$OriginalCharge10 = view.OriginalCharge) !== null && _view$OriginalCharge10 !== void 0 && _view$OriginalCharge10.TotalTaxAmount ? $filter('invCurrency')(view.OriginalCharge.TotalTaxAmount, currency, false, true) : null,
          isTaxInclusiveTagDisplayEnabled: isTaxInclusiveTagDisplayEnabled
        },
        prorate: view.Prorate,
        idTag: i18n.translate(LocaleKeys.IDENTIFIER_ABBREVIATION),
        referenceId: view.ReferenceId || null,
        subscriberItem: view.Name || null,
        serviceName: view.ServiceIdentifier && view.ServiceIdentifier.Value ? getFriendlyLedgerName(view.ServiceIdentifier) : null,
        serviceType: invoiceItemTypeName || null,
        taxMethod: getTaxMethod(view),
        isTaxInclusive: (view === null || view === void 0 ? void 0 : (_view$OriginalCharge11 = view.OriginalCharge) === null || _view$OriginalCharge11 === void 0 ? void 0 : _view$OriginalCharge11.TaxMethod) === TAX_TYPE.INCLUSIVE,
        isTaxInclusiveTagDisplayEnabled: isTaxInclusiveTagDisplayEnabled,
        totalCharge: calculateTotalCharge(view, currency, $filter, discountAmount, isTaxInclusiveTagDisplayEnabled),
        totalChargeAmount: calculateTotalChargeAmount(view, discountAmount, isTaxInclusiveTagDisplayEnabled),
        totalChargeForApplyAdjustment: calculateTotalChargeForApplyAdjustment(view, discountAmount),
        totalChargeDetails: {
          taxMethod: view === null || view === void 0 ? void 0 : (_view$TotalCharge10 = view.TotalCharge) === null || _view$TotalCharge10 === void 0 ? void 0 : _view$TotalCharge10.TaxMethod,
          baseAmount: view !== null && view !== void 0 && (_view$TotalCharge11 = view.TotalCharge) !== null && _view$TotalCharge11 !== void 0 && _view$TotalCharge11.BaseAmount ? $filter('invCurrency')(view.TotalCharge.BaseAmount, currency, false, true) : null,
          chargeAmount: view !== null && view !== void 0 && (_view$TotalCharge12 = view.TotalCharge) !== null && _view$TotalCharge12 !== void 0 && _view$TotalCharge12.ChargeAmount ? $filter('invCurrency')(view.TotalCharge.ChargeAmount, currency, false, true) : null,
          totalTaxAmount: view !== null && view !== void 0 && (_view$TotalCharge13 = view.TotalCharge) !== null && _view$TotalCharge13 !== void 0 && _view$TotalCharge13.TotalTaxAmount ? $filter('invCurrency')(view.TotalCharge.TotalTaxAmount, currency, false, true) : null,
          isTaxInclusiveTagDisplayEnabled: isTaxInclusiveTagDisplayEnabled
        }
      }, witheldTaxesApplicable && {
        withheldTaxes: view.WithheldTaxes.length > 0 ? $filter('invCurrency')(view.WithheldTaxes[0].TaxAmount, currency, false, true) : null
      });
    }
  };
  tableData.data = map(formatView, invoiceItems);
  return tableData;
}
var getDiscountAmount = function getDiscountAmount(view) {
  return view && view.TotalDiscountAmount ? view.TotalDiscountAmount : 0;
};
var getDiscountsDetails = function getDiscountsDetails(currency) {
  var discounts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var discountsMetadataMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var filteredDiscountDetails = [];
  var discountDetails = discounts.map(function (discount) {
    var _discount$TaxSummary, _discount$TaxSummary2, _discount$TaxSummary3, _discount$TaxSummary4;
    var discountName = discountsMetadataMap[discount.Id] ? discountsMetadataMap[discount.Id].StorefrontText || discountsMetadataMap[discount.Id].Name : discount.Name;
    return {
      Name: discountName,
      Amount: discount.Amount,
      Currency: currency,
      IsProrate: discount.Prorate,
      PeriodStartDate: discount.PeriodStartDate,
      PeriodEndDate: discount.PeriodEndDate,
      ChargeAmount: discount === null || discount === void 0 ? void 0 : (_discount$TaxSummary = discount.TaxSummary) === null || _discount$TaxSummary === void 0 ? void 0 : _discount$TaxSummary.ChargeAmount,
      BaseAmount: discount === null || discount === void 0 ? void 0 : (_discount$TaxSummary2 = discount.TaxSummary) === null || _discount$TaxSummary2 === void 0 ? void 0 : _discount$TaxSummary2.BaseAmount,
      TotalTaxAmount: discount === null || discount === void 0 ? void 0 : (_discount$TaxSummary3 = discount.TaxSummary) === null || _discount$TaxSummary3 === void 0 ? void 0 : _discount$TaxSummary3.TotalTaxAmount,
      IsTaxInclusive: (discount === null || discount === void 0 ? void 0 : (_discount$TaxSummary4 = discount.TaxSummary) === null || _discount$TaxSummary4 === void 0 ? void 0 : _discount$TaxSummary4.TaxMethod) === TAX_TYPE.INCLUSIVE
    };
  });
  filteredDiscountDetails = discountDetails.filter(function (discount) {
    return discount;
  });
  return filteredDiscountDetails;
};
var formatTotalCharge = function formatTotalCharge(amount, currencyCode, $filter) {
  if (amount) {
    return $filter('invCurrency')(amount, currencyCode, false, true);
  }
  return null;
};
var getFriendlyLedgerName = function getFriendlyLedgerName(serviceIdentifier) {
  var friendlyName = pathOr('', ['FriendlyName'], serviceIdentifier);
  if (friendlyName && friendlyName !== NA) {
    return friendlyName;
  } else if (friendlyName === NA) {
    return null;
  } else {
    serviceIdentifier.Value || serviceIdentifier.FormattedValue;
  }
  return friendlyName && friendlyName !== NA ? friendlyName : friendlyName === NA ? null : serviceIdentifier.Value;
};
export var getFriendlyName = function getFriendlyName(serviceIdentifier) {
  if (serviceIdentifier) {
    return serviceIdentifier.FriendlyName ? serviceIdentifier.FriendlyName : serviceIdentifier.Value;
  }
};